<template>
  <v-row class="py-0">
    <v-col cols="12">
      <h3 class="title dw_green--text font-weight-light">
        <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiAccountSupervisor" />
        User Management
      </h3>
      <v-row>
        <v-col cols="12" sm="3" offset-sm="6" class="py-0">
          <v-text-field
            v-model="search"
            color="dw_green"
            label="Search"
            clearable
            :clear-icon="mdiClose"
            single-line
            hide-details
            class="text-caption">
            <template v-slot:append>
              <v-icon small class="ml-1" v-text="mdiLayersSearchOutline" />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="9">
          <v-data-table
            dense
            :headers="headers"
            :items="users"
            :search="search"
            item-key="id"
            :single-select="true"
            @click:row="(rowItem) => selectedUser = rowItem"
            class="my-2"
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: mdiPageFirst,
              lastIcon: mdiPageLast,
              prevIcon: mdiChevronLeft,
              nextIcon: mdiChevronRight
            }"
            :options="{
              itemsPerPage: 5
            }"
          >
            <template v-slot:item.last_login="{ value }">
              <div v-if="value !== null">{{ value | moment(('L LTS'))}}</div>
            </template>
            <template v-slot:item.date_joined="{ value }">
              <div v-if="value !== null">{{ value | moment(('L'))}}</div>
            </template>
          </v-data-table>
          <v-form ref="updateUserProfileForm" v-model="formValid" @submit.prevent>
            <v-card flat color="bg_dark" v-if="selectedUser">
              <v-card-title>{{ selectedUser.username }}</v-card-title>
              <v-card-subtitle>{{ selectedUser.role }}</v-card-subtitle>
              <v-card-text class="px-4 py-0">
                <p class="text-subtitle-1 font-weight-light">Change User Role:</p>
                <v-radio-group dark v-model="userProfile">
                  <v-radio
                    v-for="prof of profileOptions"
                    :key="prof.value"
                    :label="prof.text"
                    :value="prof.value"
                    color="dw_green"
                    class="white--text"
                    :disabled="prof.value === selectedUser.role"
                  ></v-radio>
                </v-radio-group>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  type="submit"
                  color="dw_green"
                  text
                  :disabled="!formValid || !userProfile"
                  @click="updateUser"
                  title="Update User Profile">
                  Update
                  <v-icon v-text="mdiAccountEditOutline" small class="ml-2" />
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  mdiAccountSupervisor,
  mdiAccountEditOutline,
  mdiClose,
  mdiLayersSearchOutline,
  mdiPageFirst,
  mdiPageLast,
  mdiChevronLeft,
  mdiChevronRight
} from '@mdi/js';

export default {
  name: 'userManagement',
  data() {
    return {
      mdiAccountSupervisor,
      mdiAccountEditOutline,
      mdiClose,
      mdiLayersSearchOutline,
      mdiPageFirst,
      mdiPageLast,
      mdiChevronLeft,
      mdiChevronRight,
      search: '',
      headers: [
        { text: 'ID', value: 'profile_id', class: 'font-weight-regular' },
        { text: 'Username', value: 'username', class: 'font-weight-regular' },
        { text: 'Role', value: 'role', class: 'font-weight-regular' },
        { text: 'Last Seen', value: 'last_login', class: 'font-weight-regular' },
        { text: 'Joined', value: 'date_joined', class: 'font-weight-regular' }
      ],
      selectedUser: undefined,
      formValid: false,
      userProfile: undefined,
      profileOptions: [
        { text: 'Viewer', value: 'VIEWER' },
        { text: 'User', value: 'USER' },
        { text: 'Content Moderator', value: 'CONTENT MODERATOR' },
        { text: 'Admin', value: 'SUPER USER' }
      ]
    };
  },
  computed: {
    ...mapGetters([
      'users'
    ])
  },
  methods: {
    ...mapActions([
      'updateProfile',
      'archiveUser',
      'fetchUsers'
    ]),
    async updateUser() {
      try {
        await this.updateProfile({
          id: this.selectedUser.profile_id,
          role: this.userProfile
        });
        this.resetForm();
        await this.fetchUsers();
      } catch (err) {
        console.error(err);
      }
    },
    resetForm() {
      this.selectedUser = undefined;
      this.userProfile = undefined;
      this.$refs.updateUserProfileForm.resetValidation();
    }
  }
};
</script>
